module.exports = {
      id: "slider-left-arrow-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "svg-sprite-ef426a51ffa8e0d9106d678bb4289730.svg#slider-left-arrow",
      toString: function () {
        return this.url;
      }
    }